import React, { useContext, useEffect } from 'react';
import { Query } from 'react-apollo';

import { getSearchParams, queryHasCustomFilters } from './utils/searchParams';
import { CategoryDataQuery } from '../../state/services/gql/content';
import { withExperimentsState } from '../../hocs';
import DiscoveryContext from '../../contexts/discoveryContext/context';
import DiscoveryContextV2 from '../../contexts/discoveryContext/contextV2';
import CategoryPage from './container';
import CategoryMapPage from '../CategoryMapPage';

const CategoryPageWrapper = ({ data = {}, router, ...props }) => {
  const { setData } = useContext(DiscoveryContext);
  const { updateCategoryData } = useContext(DiscoveryContextV2);

  useEffect(() => {
    setData(data ?? {});
    updateCategoryData(data ?? {});
  }, [data]);

  const showMapForV2 = router?.location?.query?.map === 'true';

  return showMapForV2 ? (
    <CategoryMapPage data={data} router={router} {...props} />
  ) : (
    <CategoryPage data={data} router={router} {...props} />
  );
};

const CategoryPageWithGraphQL = (props) => {
  const {
    params,
    router,
    router: {
      location: { pathname },
    },
  } = props;
  let path = pathname.substring(1);
  if (path.endsWith('/')) {
    path = path.substring(0, path.length - 1);
  }

  const gqlParams = {
    path,
    searchParameters: getSearchParams(router.location.query),
  };

  return (
    <Query
      notifyOnNetworkStatusChange
      query={CategoryDataQuery}
      variables={gqlParams}
      errorPolicy="all"
    >
      {(gqlData) => {
        return (
          <CategoryPageWrapper
            {...props}
            {...gqlData}
            hasCustomFilters={queryHasCustomFilters(router.location.query)}
            params={{
              ...params,
              path,
              ...gqlParams.searchParameters,
            }}
          />
        );
      }}
    </Query>
  );
};

export default withExperimentsState(CategoryPageWithGraphQL);
